/**
 * Page zoom for visitors (A− / A+ next to Settings).
 *
 * Browsers do not let JavaScript change the real browser zoom, so this
 * applies CSS zoom to <html> instead — visually equivalent: text, images
 * and layout scale together and the page reflows. Saved per browser in
 * localStorage (aw_zoom) and applied at boot from src/index.js.
 */

export const ZOOM_KEY = 'aw_zoom';
const MIN = 0.8;
const MAX = 1.5;
const STEP = 0.1;

const clamp = (z) => Math.min(MAX, Math.max(MIN, Math.round(z * 10) / 10));

export const readZoom = () => {
  try {
    const z = parseFloat(localStorage.getItem(ZOOM_KEY));
    return Number.isFinite(z) ? clamp(z) : 1;
  } catch (e) { return 1; }
};

export const applyZoom = (z) => {
  const zoom = clamp(z);
  document.documentElement.style.zoom = zoom === 1 ? '' : String(zoom);
  try {
    if (zoom === 1) localStorage.removeItem(ZOOM_KEY);
    else localStorage.setItem(ZOOM_KEY, String(zoom));
  } catch (e) { /* private mode */ }
  return zoom;
};

export const zoomIn = () => applyZoom(readZoom() + STEP);
export const zoomOut = () => applyZoom(readZoom() - STEP);
